import clsx from "clsx";
import React, { forwardRef } from "react";

import { Container } from "../../container";

export interface EventDetailSectionProps {
  title: string | null;
  description?: string | null;
  isDescriptionHtml?: boolean;
  extra?: React.ReactNode;
}

export const EventDetailSection = forwardRef<HTMLDivElement, EventDetailSectionProps>(
  ({ title, description, isDescriptionHtml, extra }, ref) => {
    return (
      <Container className="my-24 px-10" ref={ref} containerFrom="xl" pagePaddingX>
        <h3 className="text-primary lg:text-center text-3xl lg:text-4xl font-medium">{title}</h3>
        <div
          className={clsx(
            "mt-12 text-lg lg:text-xl font-light",
            isDescriptionHtml ? "html-content" : "lg:text-center"
          )}
        >
          {isDescriptionHtml ? (
            <div dangerouslySetInnerHTML={{ __html: description ?? "" }} />
          ) : (
            description
          )}
        </div>
        <div className="mt-12 lg:text-center">{extra}</div>
      </Container>
    );
  }
);
